const storageKey = "batchdialer_softphone_config"

export const setBackend = (backendAPI, backendWS) => {
    if (!backendAPI && sessionStorage.getItem(storageKey) !== null) {
        sessionStorage.removeItem(storageKey)
    }

    let conf
    if (URL.canParse(backendAPI)) {
        conf = { apiEndpoint: backendAPI, wsEndpoint: backendAPI.replace("https", "wss").replace("http", "ws") }
    }

    if (URL.canParse(backendWS)) {
        conf = { wsEndpoint: backendWS }
    }

    if (conf) {
        sessionStorage.setItem(storageKey, JSON.stringify(conf))
    }
}

function storageConfigGet(key, origin) {
    const conf = sessionStorage.getItem(storageKey)
    if (!conf) return origin

    try {
        let cnf = JSON.parse(sessionStorage.getItem(storageKey))
        return cnf[key] || origin
    } catch (e) {
        console.log(e)
        return origin
    }
}

const config = {
    get apiEndpoint() {
        return storageConfigGet("apiEndpoint", "https://app.batchdialer.com/api/")
    },
    get wsEndpoint() {
        return storageConfigGet("wsEndpoint", "wss://app.batchdialer.com/api/")
    },
}

export default config
